// extracted by mini-css-extract-plugin
export var chevron = "_ik-2";
export var chevronRotated = "_ik-3";
export var header = "_ik-1";
export var section = "_ik-0";